import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import Button, { ButtonWrapper } from 'widgets/Button';

export default class ConfirmationModal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    mainViewScrollable: PropTypes.bool,
    isRequestInProgress: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onCancelLabel: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onConfirmLabel: PropTypes.string,
    title: PropTypes.string,
  };

  static defaultProps = {
    onConfirmLabel: 'OK',
    onCancelLabel: 'Cancel',
    isRequestInProgress: false,
  };

  render() {
    const {
      children,
      title,
      onConfirm,
      onConfirmLabel,
      onCancel,
      onCancelLabel,
      mainViewScrollable,
      isRequestInProgress,
      className,
    } = this.props;

    return (
      <Modal
        actions={(
          <ButtonWrapper>
            <Button
              secondary
              disabled={isRequestInProgress}
              onClick={onCancel}
            >
              {onCancelLabel}
            </Button>
            <Button
              disabled={isRequestInProgress}
              onClick={onConfirm}
            >
              {onConfirmLabel}
            </Button>
          </ButtonWrapper>
        )}
        className={className}
        mobileFullWindow={false}
        onCancel={onCancel}
        title={title}
        mainViewScrollable={mainViewScrollable}
      >
        {children}
      </Modal>
    );
  }
}
